import React from 'react';
import { Link } from 'react-router-dom'

export default function Noticeofbm(){
  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-12">
			  <h1 className="display-4 mb3 animated slideInDown">Notice of Board Meeting</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item"><Link to="/">Investor Relation</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Notice of Board Meeting</li>
				</ol>
			  </nav>
			</div>
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl py5">
		<div className="container">
		  <div className="row g-5 align-items-center">
			<div className="table-responsive table_heading">
			<table className="table table-bordered table-striped">
					<thead>
					  <tr>
						{/*<th width="20" class="text-center">No.</th>*/}
						<th className="text-left">2026-27 	</th>
						<th>Link</th>
					  </tr>
					</thead>
					<tbody>  
					<tr>
					  <td>10.08.2026</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/10.08.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>30.05.2026</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/30.05.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					</tbody>
					<thead>
					  <tr>
						{/*<th width="20" class="text-center">No.</th>*/}
						<th className="text-left">2025-26 	</th>
						<th>Link</th>
					  </tr>
					</thead>
					<tbody>  
					<tr>
					  <td>12.02.2026</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/12.02.20206.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>14.11.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/14.11.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					<tr>
					  <td>12.08.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/12.08.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					<tr>
					  <td>14.05.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/14.05.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					</tbody>
				  </table>
				  <table className="table table-bordered table-striped">
					<thead>
					  <tr>
						{/*<th width="20" class="text-center">No.</th>*/}
						<th className="text-left">Details 	</th>
						<th>Link</th>
					  </tr>
					</thead>
					<tbody>
					<tr>
					  <td>1ST BM NOTICE</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/1ST-BM-NOTICE.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>2ND BM NOTICE</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/2ND-BM-NOTICE.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>3RD BM NOTICE</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/3RD-BM-NOTICE.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>4TH BM NOTICE</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/4TH-BM-NOTICE.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>5TH BM NOTICE</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/5TH-BM-NOTICE.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>6TH BM NOTICE</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/6TH-BM-NOTICE.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>7TH BM NOTICE</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/7TH-BM-NOTICE.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>14.05.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/14.05.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>12.08.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/12.08.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>14.11.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/notice-of-BM/14.11.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					</tbody>
				  </table>
				</div>
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}